import Vue from "vue";

Vue.component("static-content-video", {
	props: [ "code" ],
	data() {
		return {
			videoList: [],
			loadingText: window.labels.loading,
			loading: true
		};
	},
	methods: {
		getContent: function () {
			this.loading = true;
			this.$services.staticVideos.getContent({
				code: this.code,
				language: window.currentLanguageInt
			}).then((data) => {
				this.videoList = data;
				this.loading = false;
			});
		}
		
	},
	mounted() {
		this.getContent();
	},
	template: `
      <div v-if="loading">
      		<loading loading-text="loadingText"></loading>
      </div>
	  <div v-else-if="!loading && videoList && videoList.length > 0">
	  	<wto-video-viewer :media="videoList"></wto-video-viewer>
	  </div>		
	`
});